export type Weekday = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';

export type Availability = {
  timezone: string;
  windows: readonly { close: string; days: readonly Weekday[]; open: string }[];
};

const WEEKDAYS: Record<string, Weekday> = {
  Fri: 'fri',
  Mon: 'mon',
  Sat: 'sat',
  Sun: 'sun',
  Thu: 'thu',
  Tue: 'tue',
  Wed: 'wed',
};

export function isOpenAt(availability: Availability, at: Date): boolean {
  const parts = new Intl.DateTimeFormat(undefined, {
    hour: '2-digit',
    hour12: false,
    minute: '2-digit',
    timeZone: availability.timezone,
    weekday: 'short',
  }).formatToParts(at);

  const weekday = WEEKDAYS[parts.find(part => part.type === 'weekday')?.value ?? ''];
  if (!weekday) return false;

  const hour = parts.find(part => part.type === 'hour')?.value ?? '';
  const minute = parts.find(part => part.type === 'minute')?.value ?? '';
  const hhmm = `${hour}:${minute}`;

  return availability.windows.some(entry => entry.days.includes(weekday) && entry.open <= hhmm && hhmm < entry.close);
}
